import type { ItemTypeMeta } from "./item"
import { bindContent, contentCatalog } from "../content/catalog"
import type { CraftingEntry } from "../content/schema"

let presentation = contentCatalog.source.presentation.crafting
export let CRAFTING_GROUPS = presentation.groups
export type CraftingGroup = string
export let CRAFTING_GROUP_LABELS = presentation.labels
export let ITEM_SOURCE_HINTS = presentation.sourceHints
// Named on a recipe card, never explained there: no hint, no jump to its recipe.
export let ITEM_UNDISCLOSED_SOURCES = new Set<string>(presentation.undisclosedSources ?? [])

export const craftingGroupFor = (itemTypeMeta: ItemTypeMeta): CraftingGroup =>
    presentation.overrides[itemTypeMeta.type] ?? presentation.byClass[itemTypeMeta.class] ?? presentation.defaultGroup

/** What the bench calls a recipe and says about it. The colour's own entry wins over the item's. */
export const craftingEntryFor = (itemTypeMeta: ItemTypeMeta): CraftingEntry => {
    const entries = presentation.entries ?? {}
    return entries[`${itemTypeMeta.type}:${itemTypeMeta.color}`] ?? entries[itemTypeMeta.type] ?? {}
}

/** The name on a tile that folds several recipes together ("Wall"), or undefined for a lone recipe. */
export const craftingFamilyTitle = (family?: string): string | undefined =>
    family ? presentation.families?.[family] : undefined

bindContent(catalog => catalog.source.presentation.crafting, next => {
    presentation = next
    CRAFTING_GROUPS = next.groups
    CRAFTING_GROUP_LABELS = next.labels
    ITEM_SOURCE_HINTS = next.sourceHints
    ITEM_UNDISCLOSED_SOURCES = new Set<string>(next.undisclosedSources ?? [])
})
